import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/mycon-logo.png";
import "../../index.css";
import axiosInstance from "../../config/axiosInstance";

function Carousel({ baseURL, clientID, AppDisplayName, appIcon, isSplashVisible }) {
    const indicator = useRef();

    const [carouselImages, setCarouselImages] = useState([]);

    useEffect(() => {
        getCarouselImages(baseURL);
    }, []);

    async function getCarouselImages() {
        try {
            const payLoad = {
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    CLIENT_ID: clientID,
                },
            };
    
            const response = await axiosInstance.post(
                `${baseURL}/GetLoadScreenImage`,
                payLoad,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
    
            if (response?.data?.STATUS) {
                const images = response.data.DATA?.map((image) => image?.image_name);
                setCarouselImages(images);
                setTimeout(() => {
                    if (indicator.current) {
                        indicator.current.click();
                    }
                }, 1000);
            }
        } catch (error) {
            console.error("Error fetching carousel images:", error);
        }
    }
    

    return (
        <div id="mainPageCarousel" className="carousel slide carousel-fade h-100" data-bs-ride="carousel" data-bs-interval="1300">
            <div className="carousel-indicators">
                {carouselImages?.length > 1 &&
                    carouselImages.map((image, index) =>
                        index === 0 ? (
                            <button type="button" data-bs-target="#mainPageCarousel" key={index} data-bs-slide-to={index} className="d-none height-10 width-10 rounded-circle active" ref={indicator}></button>
                        ) : (
                            <button type="button" data-bs-target="#mainPageCarousel" key={index} data-bs-slide-to={index} className="d-none height-10 width-10 rounded-circle"></button>
                        )
                    )}
            </div>

            <div className="carousel-inner h-100">
                {carouselImages?.length > 0 ? (
                    carouselImages?.map((image, index) => (
                        <div
                            className="carousel-item h-100 active"
                            key={index}
                            style={{ backgroundColor: isSplashVisible ? "#062D79" : "#333333", display: isSplashVisible ? "none" : "block" }} // Dark theme background color
                        >
                            <img
                                src={image}
                                onError={(e) => {
                                    e.target.src = logo;
                                }}
                                alt="company logo"
                                className="d-block h-100 mx-auto object-fit-contain w-100"
                            />
                            {/* <div className="carousel-caption">
                                <p className="font-weight-700 font-size-14 mb-0">Welcome to {AppDisplayName ? AppDisplayName : "True Value"}</p>
                            </div> */}
                        </div>
                    ))
                ) : (
                    <div
                        className="carousel-item h-100 active"
                        // key={index}
                        style={{ backgroundColor: isSplashVisible ? "#062D79" : "#333333", display: isSplashVisible ? "none" : "block" }} // Dark theme background color
                    >
                        <img src={appIcon} alt="Los Angeles" className="d-block h-100 mx-auto object-fit-contain w-100" />
                        {/* <div className="carousel-caption">
                            <p className="font-weight-700 font-size-14 mb-0">Welcome to {AppDisplayName ? AppDisplayName : "True Value"}</p>
                        </div> */}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Carousel;
